module.exports = __webpack_public_path__ + "img/next_step.0c4aee53.svg";